import * as types from './actionTypes';

function url() {
  return 'api/PersonMap/';
}


export function receivePersonMap(personMap) {
  return {
    type: types.PERSONMAP_RECEIVE, 
    personMap:   {
      mapTitle: (personMap && personMap.mapImage && personMap.mapImage.title || ''),
      thumbnailUrl: (personMap && personMap.mapImage && personMap.mapImage.thumbnailUrl || ''),
      largeUrl: (personMap && personMap.mapImage && personMap.mapImage.originalUrl || ''),
      location: {
        x:  personMap && personMap.room && personMap.room.location && personMap.room.location.x || 0,
        y: personMap && personMap.room && personMap.room.location && personMap.room.location.y || 0
      }
  },};
}

export function personSelected(person) {
  return {
    type: types.PERSON_SELECT, 
    person
  };
}

export function personMapIsLoading(bool) {
  return {
    type: types.PERSONMAP_ISLOADING, 
    isLoading: bool
  };
}

export function receivePersonAPIError(bool, errorMessage) {
  return {
    type: types.PERSONMAP_APIERROR, 
    hasErrored: bool,
    errMsg: errorMessage};
}


export function personSelect(emailAddress, displayName) {
  return (dispatch, getState) => {
    dispatch(personSelected( {
      displayName,
      emailAddress
    }
    ) )
  }
}

export function fetchPersonMap(roomName) {
  return (dispatch, getState) => {
    
    const state = getState();
    let mrm_exchangeToken ='', mrm_ssoToken= '';

    if(state != null) {
       mrm_ssoToken = state.userRegTokens.ssoToken;
       mrm_exchangeToken = state.userRegTokens.exchangeToken;
    }
    
    dispatch(personMapIsLoading(true));

    if(!mrm_exchangeToken) {
      console.log('No exchange token - skip calling personmap api...');
      return;
    }

    return fetch(url()+roomName, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + mrm_ssoToken,
        "X-ExchangeToken": mrm_exchangeToken
      }
    })
    .then( (response) => {
      if (!response.ok) { throw response }
      return response.json()  //we only get here if there is no error
    })
    .then( 
      (personMap) => {
        dispatch(receivePersonMap(personMap));
        dispatch(personMapIsLoading(false));
      }
     )
    .catch( (err) =>  {
      console.log("API Error:");
      console.dir(err);
      dispatch(receivePersonAPIError(true, err.statusText));
      dispatch(personMapIsLoading(false));
      }
    )
  };
}


